import { render } from "./BaseConfirmField.vue?vue&type=template&id=6595e49a"
import script from "./BaseConfirmField.vue?vue&type=script&lang=js"
export * from "./BaseConfirmField.vue?vue&type=script&lang=js"

import "./BaseConfirmField.vue?vue&type=style&index=0&id=6595e49a&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__